import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';

export const FormMicEstatus = (props) => {

    const {
        handleInputChange, methodAction, status,
    } = props;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className="label-admision">Nombre del estatus <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="status"
                            value={status}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className='input-admision'

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>


        </Form>
    )
}
